import Vue from 'vue'
import { Movable, MovableAnchor } from 'vue-movable-element'

Vue.component('movable', Movable)
Vue.component('movable-anchor', MovableAnchor)
